// extracted by mini-css-extract-plugin
export default {"ability":"PathMeterAbilities_ability__4cjHF"};